import INavBar from '@src/component/INavBar'
import CommonService from '@src/service/commonService'
import { getUrlParams } from '@src/util'
import { Grid } from 'antd-mobile'
import React, { useEffect, useState } from 'react'
import './index.scss'

function ViewContract(props: any) {
  const {
    location: { search },
  } = props
  const params = getUrlParams(search)
  const [detail, setDetail] = useState<any>({})

  useEffect(() => {
    CommonService.getContrackDetail({
      loaningInfoId: params.id,
    }).then((res: any) => setDetail(res || {}))
  }, [])
  const toView = (url: string) => {
    window.open(url)
  }
  return (
    <div>
      <INavBar title="相关合同" />
      {detail && detail.rejectReason && (
        <div className="reason">
          <span>
            {params.status === '1' && '驳回'}
            {params.status === '3' && '拒绝'}原因：
          </span>
          {detail.rejectReason}
        </div>
      )}
      <div className="view-page">
        <Grid columns={2} gap={20}>
          {detail &&
            detail.contractInfo &&
            detail.contractInfo.map((item: any, index: number) => (
              <Grid.Item>
                <div className="view-item">
                  <div className="item-index">合同{index + 1}</div>
                  <div className="item-name">{item.name}</div>
                  <div className="item-view" onClick={() => toView(item.url)}>
                    查看
                  </div>
                </div>
              </Grid.Item>
            ))}
        </Grid>
      </div>
    </div>
  )
}

export default ViewContract
